import React, { useState, useEffect, useCallback } from 'react';
import { Card, CardBody, Row, Col, Progress, Container } from 'reactstrap';

const StatusDashboard = () => {
  const [stats, setStats] = useState({
    active: 0,
    limit: 0,
    credits: 0
  });

  const loadData = useCallback(() => {
    const active = parseInt(localStorage.getItem('active_offers')) || 0;
    const limit = parseInt(localStorage.getItem('active_offers_limit')) || 0;
    const credits = parseInt(localStorage.getItem('available_credits')) || 0;
    
    setStats(prev => {
      if (prev.active === active && prev.limit === limit && prev.credits === credits) {
        return prev;
      }
      return { active, limit, credits };
    });
  }, []);

  useEffect(() => {
    loadData();

    const handleStorageChange = (e) => {
      const keys = ['active_offers', 'active_offers_limit', 'available_credits'];
      if (keys.includes(e.key)) loadData();
    };

    const handleLocalUpdate = () => loadData();

    const interval = setInterval(loadData, 500);

    window.addEventListener('storage', handleStorageChange);
    window.addEventListener('local-storage-update', handleLocalUpdate);

    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('local-storage-update', handleLocalUpdate);
      clearInterval(interval);
    };
  }, [loadData]);

  const getStatusColor = (type) => {
    if (type === 'offers') {
      const ratio = stats.limit > 0 ? stats.active / stats.limit : 0;
      return ratio >= 0.9 ? 'danger' : ratio >= 0.6 ? 'warning' : 'success';
    }
    return stats.credits <= 5 ? 'danger' : stats.credits <= 15 ? 'warning' : 'primary';
  };

  return (
    <Container className="d-flex align-items-center justify-content-center" style={{ marginBottom: '50px', marginTop: '-50px' }}>
      <Row className="justify-content-center w-100 g-4">
        
        <Col xs="12" sm="6" md="5" lg="4">
          <Card className="h-100 border-0 shadow-lg p-2 transition-all" style={{ borderRadius: '20px' }}>
            <CardBody className="d-flex flex-column justify-content-between">
              <div>
                <div className="d-flex justify-content-between align-items-start mb-3">
                  <div className={`p-2 rounded-3 bg-${getStatusColor('offers')} bg-opacity-10`} style={{ fontSize: '1.5rem' }}>
                    💼
                  </div>
                  <span className={`badge rounded-pill bg-${getStatusColor('offers')}`}>
                    {stats.limit > 0 ? Math.round((stats.active / stats.limit) * 100) : 0}% de uso
                  </span>
                </div>
                <h6 className="text-muted small text-uppercase fw-bold mb-1">Ofertas Activas</h6>
                <h2 className="fw-bold mb-0">
                  {stats.active} <small className="text-muted fs-6">/ {stats.limit}</small>
                </h2>
              </div>
              
              <div className="mt-4">
                <Progress 
                  value={stats.limit > 0 ? (stats.active / stats.limit) * 100 : 0} 
                  color={getStatusColor('offers')} 
                  style={{ height: '8px', borderRadius: '10px' }} 
                  className="mb-2"
                />
                <p className="text-muted small mb-0">Espacio disponible para nuevas ofertas</p>
              </div>
            </CardBody>
          </Card>
        </Col>

        <Col xs="12" sm="6" md="5" lg="4">
          <Card className="h-100 border-0 shadow-lg p-2 transition-all" style={{ borderRadius: '20px' }}>
            <CardBody className="d-flex flex-column justify-content-between">
              <div>
                <div className="d-flex justify-content-between align-items-start mb-3">
                  <div className={`p-2 rounded-3 bg-${getStatusColor('credits')} bg-opacity-10`} style={{ fontSize: '1.5rem' }}>
                    🪙
                  </div>
                  {stats.credits <= 5 && (
                    <span className="badge bg-danger p-2" style={{ animation: 'pulse 1.5s infinite' }}>
                      Crítico
                    </span>
                  )}
                </div>
                <h6 className="text-muted small text-uppercase fw-bold mb-1">Créditos Disponibles</h6>
                <h2 className={`fw-bold mb-0 text-${getStatusColor('credits')}`}>
                  {stats.credits}
                </h2>
              </div>

              <div className="mt-4">
                <div className={`alert alert-${getStatusColor('credits')} py-2 mb-0 border-0 small d-flex align-items-center transition-all`}>
                  {stats.credits <= 5 ? '🛑 Es necesario recargar' : '✅ Créditos suficientes'}
                </div>
              </div>
            </CardBody>
          </Card>
        </Col>

      </Row>
      
      <style>{`
        .transition-all { transition: all 0.3s ease-in-out; }
        @keyframes pulse {
          0% { opacity: 1; transform: scale(1); }
          50% { opacity: 0.7; transform: scale(1.05); }
          100% { opacity: 1; transform: scale(1); }
        }
      `}</style>
    </Container>
  );
};

export default StatusDashboard;